export enum ProjectItemUpdateTypes {
  propertiesUpdated = 'PROPERTIES_UPDATED',
  sizeDataUpdated = 'SIZE_DATA_UPDATED',
  notesUpdated = 'NOTES_UPDATED'
}
